import request from '../utils/http/request.js'

//模擬數據
export async function stadium_list({ pageNumber, pageSize }) {
    return [{
        gymId: '',
        gymName: '臺中市場館',
        gymImage: '',
        //地址
        distance: '',
        priceMin: 1,
        priceMax: 500
    }]
}


//場次資訊
export function matches_block_list({ type, pageNumber, pageSize }) {
    const columns = [];
    let item = {
        id: 1,
        name: '場次1',
        type: type,
        stadium: '籃球場1',
        gymnaium: '東海大學體育館',
        status: '啟用',
        createTime: '2025/06/01 06:11',
    };
    columns.push({ title: '場次名稱', dataIndex: 'name', key: 'name', })
    columns.push({ title: '場次類型', dataIndex: 'type', key: 'type', })
    columns.push({ title: '所屬場地', dataIndex: 'stadium', key: 'stadium', })
    columns.push({ title: '所屬場館', dataIndex: 'gymnaium', key: 'gymnaium', })

    switch (type) {
        case '課程':
            columns.push({ title: '課程主題', dataIndex: 'courseName', key: 'courseName', })
            columns.push({ title: '課程簡述', dataIndex: 'courseInfo', key: 'courseNameInfo', })
            columns.push({ title: '課程教練', dataIndex: 'courseCoach', key: 'courseCoach', })
            columns.push({ title: '課程費用', dataIndex: 'courseCost', key: 'courseCost', })
            item.courseName = '成人培訓班'
            item.courseInfo = '為18歲以上的成人開的培訓班'
            item.courseCoach = '李教練'
            item.courseCost = '200（已包含空調費）'
            break;
        case '活動':
            columns.push({ title: '活動主題', dataIndex: 'activityName', key: 'activityName', })
            columns.push({ title: '活動內容', dataIndex: 'activityInfo', key: 'activityNameInfo', })
            columns.push({ title: '活動費用', dataIndex: 'activityCost', key: 'activityCost', })
            item.activityName = '夏日排球比賽'
            item.activityInfo = '夏天打的排球活動'
            item.activityCost = '50（空調費用：50）'
            break;
        case '臨打場':
            columns.push({ title: '費用', dataIndex: 'lindaCost', key: 'lindaCost', })
            item.lindaCost = '50（空調費用：50）'
            break;
        case '季租':
            columns.push({ title: '承租人', dataIndex: 'lessee', key: 'lessee', })
            columns.push({ title: '承租人聯絡電話', dataIndex: 'lesseePhone', key: 'lesseePhone', })
            columns.push({ title: '季租費用', dataIndex: 'rent', key: 'rent', })
            columns.push({ title: '備註', dataIndex: 'leaseNotes', key: 'leaseNotes', })
            item.lessee = '張先生'
            item.lesseePhone = '09000000'
            item.rent = '3000'
            item.leaseNotes = '這是備註'
            break;
        case '館方維護':
            break;
    }
    columns.push({ title: '場次狀態', dataIndex: 'status', key: 'status', width: 150, scopedSlots: { customRender: 'status' }, })
    columns.push({
        title: '添加時間',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 180,
    })
    columns.push({
        title: '操作',
        key: 'operation',
        fixed: 'right',
        width: "330",
        scopedSlots: { customRender: 'action' },
    })

    const list = [];
    for (let i = 0; i < 10; i++) {
        list.push(item);
    }
    return {
        columns,
        list
    };
}






/* 場館列表 */
export async function venues_list({ venueCode, venueName, sportTypeCode, status, areaCode, pageSize, pageNumber }) {
    return await request.get('/venues', {
        params: {
            venueCode, venueName, sportTypeCode, status, areaCode, pageSize, pageNumber
        }
    });
}

/* 場館詳情 */
export async function venues_detail(id) {
    return await request.get(`/venues/${id}`);
}

/* 場館添加 */
export async function venues_add({ mchNo, venueName, areaCode, venueImage, businessHours, address, longitude, latitude, contactPhone, promoVideo, features, usageRules, status }) {
    return await request.post('/venues', {
        mchNo, venueName, areaCode, venueImage, businessHours, address, longitude, latitude, contactPhone, promoVideo, features, usageRules, status
    });
}

/* 場館編輯 */
export async function venues_update({ id, mchNo, venueName, areaCode, venueImage, businessHours, address, longitude, latitude, contactPhone, promoVideo, features, usageRules, status }) {
    return await request.put(`/venues/${id}`, {
        mchNo, venueName, areaCode, venueImage, businessHours, address, longitude, latitude, contactPhone, promoVideo, features, usageRules, status
    });
}

/* 場館刪除 */
export async function venues_del(id) {
    return await request.delete(`/venues/${id}`);
}

/* 場館狀態編輯 */
export async function venues_changeState(id, status) {
    return await request.put(`/venues/changeState/${id}`, {
        status
    });
}




/* 場地 */

export async function playingField_list({ venueCode, fieldName, status, pageSize, pageNumber }) {
    return await request.get('/playingField', {
        params: {
            venueCode, fieldName, status, pageSize, pageNumber
        }
    });
}

export async function playingField_detail(id) {
    return await request.get(`/playingField/${id}`, {});
}

export async function playingField_insert({ fieldName, sportTypeCode, venueCode, status, sortOrder }) {
    return await request.post('/playingField', {
        fieldName, sportTypeCode, venueCode, status, sortOrder
    });
}


export async function playingField_update({ id, fieldName, sportTypeCode, venueCode, status }) {
    return await request.put(`/playingField/${id}`, {
        fieldName, sportTypeCode, venueCode, status
    });
}

export async function playingField_changeStatus(id, status) {
    return await request.put(`/playingField/changeStatus/${id}`, {
        status
    });
}

export async function playingField_del(id) {
    return await request.delete(`/playingField/${id}`, {});
}



/* 場次時段 */
export async function timeSlot_list({ venueCode, fieldCode, sDate, eDate, pageNumber, pageSize }) {
    return await request.get('/timeSlot', {
        params: {
            venueCode, fieldCode, sDate, eDate, pageNumber, pageSize
        }
    });
}


export async function timeSlot_detail(id) {
    return await request.get(`/timeSlot/${id}`, {});
}

export async function timeSlot_update({ id, name, fieldCode, venueCode, serviceTypeCode, serviceId, status, date, startTime, endTime, price, type }) {
    return await request.put(`/timeSlot/${id}`, {
        name, fieldCode, venueCode, serviceTypeCode, serviceId, status, date, startTime, endTime, price, type
    });
}

export async function timeSlot_insert({ fieldCode, venueCode, serviceTypeCode, serviceId, status, date, timeSlots }) {
    return await request.post(`/timeSlot`, {
        fieldCode, venueCode, serviceTypeCode, serviceId, status, date, timeSlots
    });
}

export async function timeSlot_del(id) {
    return await request.delete(`/timeSlot/${id}`, {});
}


